import lazyFn from "@/util/lazy-fn.mjs";

const fetchMapData = lazyFn(
  () => import("@/game-palworld/fetches/fetch-map-data.mjs"),
);

export default [
  {
    path: "/palworld/overlay/map-marker",
    component: "game-palworld/MapMarkerOverlay.tsx",
    fetchData: fetchMapData,
  },
];
